import { gql } from 'graphql-request';

export default gql`
  query Menus(
    $skip: Int
    $take: Int
    $orderBy: JSON
    $filters: JSON
    $mask: String
  ) {
    menus(
      skip: $skip
      take: $take
      orderBy: $orderBy
      filters: $filters
      mask: $mask
    ) {
      totalCount
      skip
      take
      menus {
        id
        account_id
        doc
        listing
        usedBy
        createdAt
        updatedAt

        Greeting {
          id
          doc
        }
      }
    }
  }
`;
